import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const spacerPropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Space Reservation Properties',
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('spacer', context.id);
		},
		isVisible: ({ refMap }): boolean => {
			return refMap?.panelItem?.item.category?.key === 'spacer';
		}
	};
};
